import React from "react";
import { Switch } from "react-router-dom";
import ScrollTopRoute from "components/ScrollTopRoute";
import Tile from "components/Tile";
import TileBody from "components/TileBody";
import PageTabs, { TAB } from "containers/BudgetHome/PageTabs";
import Fertiliser from "./Fertiliser";
import FertiliserCreate from "./FertiliserCreate";
import FertiliserEdit from "./FertiliserEdit";
import FertiliserApplications from "./Applications";
import DCD from "./DCD/DCD";

const FertiliserTab = (props) => {
    const { farm, budget } = props;
    return (
        <Tile>
            <PageTabs farmId={farm.id} budget={budget} tab={TAB.FERTILISER} />
            <TileBody>
                <Switch>
                    <ScrollTopRoute path="/app/farm/:farmId/analysis/:budgetId/fertiliser" exact render={(p) => <Fertiliser {...props} />} restoreScrollY />
                    <ScrollTopRoute path="/app/farm/:farmId/analysis/:budgetId/fertiliser/new" exact render={(p) => <FertiliserCreate {...props} />} />
                    <ScrollTopRoute path="/app/farm/:farmId/analysis/:budgetId/fertiliser/applications" exact render={(p) => <FertiliserApplications {...props} />} />
                    <ScrollTopRoute path="/app/farm/:farmId/analysis/:budgetId/fertiliser/dcd" render={(p) => <DCD {...props} />} />
                    <ScrollTopRoute path="/app/farm/:farmId/analysis/:budgetId/fertiliser/:fertiliserId" exact render={(p) => <FertiliserEdit {...props} />} />
                </Switch>
            </TileBody>
        </Tile>
    );
};

export default FertiliserTab;
